import { modal, button } from '../common/Modal.js';
import { reviewImport } from '../../domain/services/RaceImport.js';
export function showRaceImport(resume, onImport) {
  const dialog = modal('Import race history');
  const instructions = document.createElement('p'); instructions.textContent = 'Export your spreadsheet as CSV. Required columns: raceName, distance (km). Optional: time (HH:MM:SS or DNF), date (YYYY or YYYY-MM-DD), location, type (road/trail), elevation (m), notes, resultsLink, isTimed (true/false). Review before adding.';
  const file = document.createElement('input'); file.type = 'file'; file.accept = '.csv,text/csv'; file.setAttribute('aria-label', 'Choose race CSV');
  const content = document.createElement('div'); const status = document.createElement('p'); status.setAttribute('role', 'status');
  let ready = [];
  const save = button('Add reviewed races', async () => {
    save.disabled = true; file.disabled = true;
    try { await onImport(ready); dialog.close(); }
    catch (error) { status.textContent = error.message || 'Import failed. Try again.'; save.disabled = false; file.disabled = false; }
  }); save.disabled = true;
  file.addEventListener('change', async () => {
    ready = []; content.replaceChildren(); save.disabled = true;
    try {
      if (!file.files[0]) return;
      if (file.files[0].size > 250000) throw new Error('Choose a CSV smaller than 250 KB.');
      const rows = reviewImport(await file.files[0].text(), resume.races);
      for (const row of rows) {
        const label = document.createElement('label'); const input = document.createElement('input'); input.type = 'checkbox';
        input.disabled = row.errors.length > 0 || row.duplicate; input.checked = !input.disabled;
        row.race.id = crypto.randomUUID();
        const update = () => { ready = rows.filter(r => r.input.checked && !r.input.disabled).map(r => r.race); save.disabled = !ready.length; save.textContent = `Add ${ready.length} reviewed races`; };
        row.input = input; input.addEventListener('change', update);
        label.append(input, document.createTextNode(`Row ${row.row}: ${row.race.raceName} · ${row.race.distance} km · ${row.race.date || 'No date'}${row.duplicate ? ' — duplicate skipped' : row.errors.length ? ' — ' + row.errors.join('; ') : ''}`));
        content.append(label);
      }
      ready = rows.filter(r => r.input.checked).map(r => r.race);
      save.disabled = !ready.length; save.textContent = `Add ${ready.length} reviewed races`;
      status.textContent = `${rows.length} rows reviewed. Invalid rows and matching name/date/distance entries are skipped.`;
    } catch (error) { status.textContent = error.message; }
  });
  dialog.append(instructions, file, status, content, save);
}
